import { Editor } from 'grapesjs';

const cmdVis = 'sw-visibility';

export const PreviewCommand = {
  run(this: any, editor: Editor, sender: any) {
    this.sender = sender;
    this.selected = [...editor.getSelectedAll()];
    editor.select();

    if (!this.shouldRunSwVisibility) {
      this.shouldRunSwVisibility = editor.Commands.isActive(cmdVis);
    }

    this.shouldRunSwVisibility && editor.stopCommand(cmdVis);
    editor.getModel().stopDefault();

    editor.DomComponents.getWrapper().onAll((comp: any) => comp.set({ editable: false }));

    editor.Canvas.getBody().classList.add('preview');
    editor.refresh();
    this.tglEffects(1);
  },

  stop(this: any, editor: Editor) {
    const { sender = {}, selected } = this;
    sender.set && sender.set('active', 0);

    if (this.shouldRunSwVisibility) {
      editor.runCommand(cmdVis);
      this.shouldRunSwVisibility = false;
    }

    editor.getModel().runDefault();

    editor.DomComponents.getWrapper().onAll((comp: any) => comp.set({ editable: true }));

    editor.Canvas.getBody().classList.remove('preview');

    selected && editor.select(selected);
    delete this.selected;

    editor.refresh();
    this.tglEffects();
  },
};
